export default "__VITE_ASSET__Cxl5UnSE__"